/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_SavingInputs */



/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Iconik_Metadata_SavingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_saving = /** @type {((inputs?: Iconik_Metadata_SavingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_SavingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Saving…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saving…")
	return /** @type {LocalizedString} */ ("Saving…")
});